import script from "./EditStoriesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditStoriesPage.vue?vue&type=script&setup=true&lang=js"

import "./EditStoriesPage.vue?vue&type=style&index=0&id=5f046638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f046638"]])

export default __exports__